import axios from 'axios';
import { getGuestToken } from '../utils/authHelpers';

const guestHttp = axios.create({
  baseURL: 'https://api.easyworldonline.com',
  headers: { Accept: 'application/json' },
});

guestHttp.interceptors.request.use((config) => {
  const token = getGuestToken(); // reads localStorage key "guestToken"
  if (token) config.headers['X-Guest-Token'] = token;
  return config;
});

guestHttp.interceptors.response.use(
  (res) => res,
  (err) => Promise.reject(err),
);

export default guestHttp;